import styled from 'styled-components';
import { Grid, Typography, Link, MenuItem } from '@material-ui/core';

// CONSTANTS
import colors from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

// COMPONENTS
import Sticky from '@/components/Sticky';

export const GridContainer = styled(Grid)`
  height: calc(100vh - 160px);
  overflow: auto;
`;

export const Container = styled.div`
  padding-top: 15px;
  padding-bottom: 15px;
`;

export const ChannelStepContainer = styled.div`
  margin: 45px 0;
  ${breakpoints.down('xs')} {
    margin-top: 105px;
  }

  .looking-for-more {
    font-weight: 400;
  }
`;

export const ChannelHeader = styled.div`
  box-shadow: none;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: ${p => p.theme.palette.background.default};

  .channel-header {
    &__fields-container {
      ${breakpoints.down('xs')} {
        &.MuiGrid-spacing-xs-4 {
          width: calc(100% + 16px);
          margin: -8px;
        }

        &.MuiGrid-spacing-xs-4 > .MuiGrid-item {
          padding: 8px;
        }
      }
    }
  }
`;

export const TitleContainer = styled.div`
  margin-bottom: 24px;
`;

export const Title = styled(Typography)`
  margin-bottom: 15px;

  span {
    font-size: 2.4rem;
    color: ${colors.textSecondary};
  }
`;

export const TopChannelsContainer = styled(Grid)`
  position: relative;
  margin-top: 20px;
  margin-bottom: 50px;
  min-height: 153px;
`;

export const ChannelsWrapper = styled.div`
  min-height: calc(100vh - 176px);

  ${breakpoints.down('xs')} {
    min-height: calc(100vh - 234px);
  }
`;

export const ChannelsContainer = styled(TopChannelsContainer)`
  margin-bottom: 115px;
  align-items: flex-start;

  ${breakpoints.down('sm')} {
    margin-bottom: 200px;
  }
`;

export const TermsContainer = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TermsText = styled.p`
  font-size: 1.4rem;
  line-height: 1.6rem;
  font-weight: 500;
  margin: 0;
`;

export const TermsLink = styled(Link)`
  font-size: 1.4rem;
  line-height: 1.6rem;
  font-weight: 500;
`;

export const GenreMenuItem = styled(MenuItem)`
  padding-top: 8px;
  padding-bottom: 8px;
`;

export const StyledSticky = styled(Sticky)`
  ${breakpoints.down('xs')} {
    &.active {
      .sticky-inner-wrapper {
        .channel-header__fields-container-item-genre {
          display: none;
        }
      }
    }
  }
`;
